/* eslint-disable implicit-arrow-linebreak */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EventResponse, EventType } from "./types";

interface EventSlice {
  // We cannot use Moments in the state due to the error: "A non-serializable value was detected in the state"
  event: EventResponse | null;
  eventType: EventType | null;
  eventPrice: number | null;
  isPaymentDisabled: boolean;
}

const initialState: EventSlice = {
  event: null,
  eventType: null,
  eventPrice: null,
  isPaymentDisabled: false,
};

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setEvent(state, { payload }: PayloadAction<EventResponse>) {
      state.event = payload;
    },
    setEventPrice(state, action: PayloadAction<number | null>) {
      state.eventPrice = action.payload;
    },
    setIsPaymentDisabled(state, action: PayloadAction<boolean>) {
      state.isPaymentDisabled = action.payload;
    },
    clearEventState(state) {
      state.event = null;
      state.eventType = null;
      state.eventPrice = 0;
    },
    setEventType(state, action: PayloadAction<EventType>) {
      state.eventType = action.payload;
    },
  },
});

export const {
  setEvent,
  setEventPrice,
  setIsPaymentDisabled,
  clearEventState,
  setEventType,
} = eventSlice.actions;

export default eventSlice.reducer;
